import React from 'react';
import { useTranslation } from 'react-i18next';
import PublicLayout from '../components/PublicLayout';
import './CommonPages.css';

const Status = () => {
  const { i18n } = useTranslation();
  const tr = i18n.language?.startsWith('tr');

  const services = [
    { name: 'VPN Gateway', uptime: '99.98%', response: '12ms' },
    { name: 'Auth Service', uptime: '99.99%', response: '8ms' },
    { name: 'Admin Console', uptime: '99.95%', response: '45ms' },
    { name: 'API', uptime: '99.97%', response: '22ms' },
    { name: 'Database', uptime: '100%', response: '3ms' },
  ];

  const incidents = tr
    ? [
        { date: '25 Eki 2025', title: 'Planlı bakım', desc: 'Kontrol düzlemi güncellemeleri tamamlandı.', status: 'Çözüldü' },
        { date: '20 Eki 2025', title: 'Bölgesel yavaşlama', desc: 'EU bölgesinde kısa süreli gecikme artışı.', status: 'Çözüldü' },
      ]
    : [
        { date: '25 Oct 2025', title: 'Scheduled maintenance', desc: 'Control-plane updates completed successfully.', status: 'Resolved' },
        { date: '20 Oct 2025', title: 'Regional slowdown', desc: 'Brief latency increase in the EU region.', status: 'Resolved' },
      ];

  return (
    <PublicLayout
      title={tr ? 'Sistem durumu' : 'System status'}
      subtitle={tr ? 'Temel servislerin anlık görünümü.' : 'A live view of core service health.'}
    >
      <div className="common-page">
        <div className="status-banner-modern arc-panel">
          <span className="status-dot-live" />
          <div>
            <h3>{tr ? 'Tüm sistemler çalışıyor' : 'All systems operational'}</h3>
            <p>{tr ? 'Son kontrol:' : 'Last checked:'} {new Date().toLocaleString(tr ? 'tr-TR' : 'en-US')}</p>
          </div>
        </div>

        <section className="arc-section">
          <div className="arc-section-head">
            <h2>{tr ? 'Servisler' : 'Services'}</h2>
          </div>
          <div className="services-modern">
            {services.map((service) => (
              <article className="arc-panel service-modern" key={service.name}>
                <div>
                  <span className="status-dot-live" />
                  <h3>{service.name}</h3>
                </div>
                <div className="service-metrics-modern">
                  <span>Uptime {service.uptime}</span>
                  <span>Response {service.response}</span>
                </div>
              </article>
            ))}
          </div>
        </section>

        <section className="arc-section">
          <div className="arc-section-head">
            <h2>{tr ? 'Son olaylar' : 'Recent incidents'}</h2>
          </div>
          <div className="incidents-modern">
            {incidents.map((incident) => (
              <article className="arc-panel" key={incident.title + incident.date}>
                <p className="incident-date-modern">{incident.date}</p>
                <h3>{incident.title}</h3>
                <p>{incident.desc}</p>
                <span className="incident-chip">{incident.status}</span>
              </article>
            ))}
          </div>
        </section>
      </div>
    </PublicLayout>
  );
};

export default Status;
